/**
 * @generated SignedSource<<aecd060a31c6a0e1cdb0d89da8ddd53d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type HsRegisterOauthTokensInput = {
  clientMutationId?: string | null | undefined;
  code?: string | null | undefined;
};
export type Integration_HubspotRegisterOauth_Mutation$variables = {
  input: HsRegisterOauthTokensInput;
};
export type Integration_HubspotRegisterOauth_Mutation$data = {
  readonly hsRegisterOauthTokens: {
    readonly success: boolean | null | undefined;
  } | null | undefined;
};
export type Integration_HubspotRegisterOauth_Mutation = {
  response: Integration_HubspotRegisterOauth_Mutation$data;
  variables: Integration_HubspotRegisterOauth_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "HsRegisterOauthTokensPayload",
    "kind": "LinkedField",
    "name": "hsRegisterOauthTokens",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "Integration_HubspotRegisterOauth_Mutation",
    "selections": (v1/*: any*/),
    "type": "RootMutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "Integration_HubspotRegisterOauth_Mutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "521e34e0dbaaa35b68d3f95d35eae275",
    "id": null,
    "metadata": {},
    "name": "Integration_HubspotRegisterOauth_Mutation",
    "operationKind": "mutation",
    "text": "mutation Integration_HubspotRegisterOauth_Mutation(\n  $input: HsRegisterOauthTokensInput!\n) {\n  hsRegisterOauthTokens(input: $input) {\n    success\n  }\n}\n"
  }
};
})();

(node as any).hash = "ec4282c14713b3ef905881440fa32f33";

export default node;
